import { DB_FETCH_PAGE_SIZE } from 'utils/dbFetchPage';
import { isCatalogCostPriceLog } from './catalogCostPriceLog';

/** Rows per /logs table page — same size as the searchlogs / getlogs DB page. */
export const ACTIVITY_LOGS_PER_PAGE = DB_FETCH_PAGE_SIZE;

export type ActivityLogsTableAmountLog = {
  id?: string | number | null
  value?: string | number | null
  units?: string | number | null
  data?: { units?: string | number | null }
  catalogCostPrice?: unknown
  eventType?: unknown
  event_type?: unknown
};

/** N/A and non-numeric activity values do not move the footer total. */
export const activityLogsTableAmountNumber = (value?: string | number | null): number => {
  if (value == null || value === '' || value === 'N/A') return 0;
  return Number(value) || 0;
};

/**
 * Sum cash or units for every filtered activity — not the current paginator page.
 * Page-only sums jump (e.g. 0 then 16) when early pages are N/A hospitality.
 * Catalog cost overlays are inventory metadata — never move the cash footer.
 */
export const sumActivityLogsTableAmount = (
  logs: ActivityLogsTableAmountLog[],
  mode: 'value' | 'units' = 'value',
): number => (
  logs.reduce((sum, log) => {
    // if (isCatalogCostPriceLog(log)) return sum;
    if (mode === 'units') {
      const raw = log.units ?? log.data?.units;
      if (raw == null || raw === '') return sum;
      return sum + (Number(raw) || 0);
    }
    return sum + activityLogsTableAmountNumber(log.value);
  }, 0)
);

/** Slice one /logs page without mutating the filtered list. */
export const paginateActivityLogsTable = <T>(
  logs: T[],
  page: number,
  perPage: number = ACTIVITY_LOGS_PER_PAGE,
): T[] => {
  const safePage = Math.max(1, page);
  const start = (safePage - 1) * perPage;
  return logs.slice(start, start + perPage);
};

export const activityLogsTablePageCount = (
  total: number,
  perPage: number = ACTIVITY_LOGS_PER_PAGE,
): number => {
  if (total <= 0) return 0;
  return Math.ceil(total / perPage);
};
